import { Paragraph, Tag } from '@zillow/constellation-10';
import { LeaseStatus } from '@zg-rentals/ts-rental-manager-api-client';
import type { Lease } from '../../../models';
import { LoadingText } from '@zg-rentals/loading-components';

type Props = {
  lease?: Lease;
};

export default function ColandlordLeaseStatus({ lease }: Props) {
  if (!lease) {
    return (
      <>
        <LoadingText isLoading loadingWidth="50%" css={{ marginBottom: 'tighter' }}>
          Loading
        </LoadingText>
        <LoadingText isLoading loadingWidth="100%">
          Loading
        </LoadingText>
      </>
    );
  }

  const { creationDate, updateDate, startDate, sharedDate } = lease;

  const statusExtraMap = {
    [LeaseStatus.INCOMPLETE_DRAFT]: creationDate ? (
      <Paragraph css={{ textStyle: 'body-sm' }}>Creation started {lease.getFriendlyCreationDate()}</Paragraph>
    ) : null,
    [LeaseStatus.COMPLETE_DRAFT]: updateDate ? (
      <Paragraph css={{ textStyle: 'body-sm' }}>Completed {lease.getFriendlyUpdatedDate()}</Paragraph>
    ) : null,
    [LeaseStatus.SENT_COMPLETE_DRAFT]: updateDate ? (
      <Paragraph css={{ textStyle: 'body-sm' }}>Last edited {lease.getFriendlyUpdatedDate()}</Paragraph>
    ) : null,
    [LeaseStatus.SENT_INCOMPLETE_DRAFT]: updateDate ? (
      <Paragraph css={{ textStyle: 'body-sm' }}>Last edited {lease.getFriendlyUpdatedDate()}</Paragraph>
    ) : null,
    [LeaseStatus.SENT_FOR_ONLINE_SIGNING]: <></>,
    [LeaseStatus.SIGNING_CANCELLED]: <></>,
    [LeaseStatus.SENT_FOR_OFFLINE_SIGNING]: sharedDate ? (
      <Paragraph css={{ textStyle: 'body-sm' }}>Offline signing requested on {lease.getFriendlySharedDate()}</Paragraph>
    ) : null,
    [LeaseStatus.SIGNING_COMPLETE]:
      updateDate && startDate ? (
        <Paragraph css={{ textStyle: 'body-sm' }}>Lease becomes active on {lease.getFriendlyStartDate()}</Paragraph>
      ) : null,
    [LeaseStatus.ACTIVE]: updateDate ? (
      <Paragraph css={{ textStyle: 'body-sm' }}>Lease signed on {lease.getFriendlyUpdatedDate()}</Paragraph>
    ) : null,
    [LeaseStatus.EXPIRED]: updateDate ? (
      <Paragraph css={{ textStyle: 'body-sm' }}>Expired {lease.getFriendlyUpdatedDate()}</Paragraph>
    ) : null,
    [LeaseStatus.SIGNED_BY_TENANT]: (
      <>
        {sharedDate && (
          <Paragraph css={{ textStyle: 'body-sm' }}>
            The landlord requested signatures {lease.getFriendlySharedDate()}
          </Paragraph>
        )}
      </>
    ),
    [LeaseStatus.COUNTERSIGNING]: <></>,
  };

  return (
    <>
      <Tag css={{ marginBottom: 'tighter' }} tone={lease.getBadgeColor()}>
        {lease.getHumanReadableStatus()}
      </Tag>
      {statusExtraMap[lease.status]}
    </>
  );
}
